{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Izberite element",
  "tableResizer": "Spreminjanje velikosti",
  "colorSwatchPicker": "Color swatches"
}
